import script from "./CompositeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompositeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./CompositeSelector.vue?vue&type=style&index=0&id=f8c74f44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8c74f44"]])

export default __exports__